export default __webpack_public_path__ + "256e1cbf12325d6c79e634ef0984c75f.png";